import { css } from '@emotion/react';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { margin, MarginProps } from 'styled-system';

import { theme } from '@/styles/theme';
import { Colors } from '@/styles/themes/colors';
import { FontSizesKey } from '@/styles/themes/font-sizes';

import iconSet from './selection.json';

// FIXME: 定義はjsonから取得したい
export type IconName =
  | 'alert'
  | 'calendar-clock'
  | 'camera'
  | 'check'
  | 'chevron-left'
  | 'chevron-right'
  | 'clipboard'
  | 'circle-plus'
  | 'delete'
  | 'home'
  | 'pencil'
  | 'pin'
  | 'photo'
  | 'qrcode'
  | 'send'
  | 'search'
  | 'store'
  | 'user'
  | 'user-group';

type Props = MarginProps & {
  color?: keyof Colors['fill'];
  size?: FontSizesKey;
  icon: IconName;
  className?: string;
  width?: string;
  height?: string;
};

const Icons = styled(IcomoonReact)<MarginProps>(
  () =>
    css({
      flexShrink: 0,
    }),
  margin
);

export const Icon = (props: Props) => {
  const { color, size, icon, ...styles } = props;

  return (
    <Icons
      {...styles}
      iconSet={iconSet}
      color={color && theme.colors.fill[color]}
      size={size && theme.fontSizes[size]}
      icon={icon}
    />
  );
};
